// rfc
import React from 'react';
import Styles from './Loader.module.css';

const Loader = () => {
   return <div className={Styles.loader}></div>;
};

export default Loader;
